"use client";
import React from "react";
import { useRouter } from "next/navigation";

const BackBtn: React.FC<{ dark?: boolean }> = ({ dark }) => {
  const router = useRouter();
  const handleBack = () => {
    router.back();
  };
  return (
    <button
      className={`flex text-white gap-2 ${dark && "!text-primary"}`}
      onClick={handleBack}
    >
      <BackIcon dark={dark} />
      Back
    </button>
  );
};

export default BackBtn;

export const BackIcon: React.FC<{ dark?: boolean }> = ({ dark }) => {
  return (
    <svg
      width="13"
      height="24"
      viewBox="0 0 13 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.2656 21.9765C12.3738 22.091 12.4584 22.2257 12.5145 22.3729C12.5707 22.5201 12.5973 22.6769 12.5928 22.8343C12.5884 22.9918 12.553 23.1468 12.4886 23.2906C12.4242 23.4344 12.3321 23.5641 12.2176 23.6723C12.1031 23.7805 11.9685 23.8651 11.8213 23.9212C11.6741 23.9774 11.5173 24.004 11.3598 23.9995C11.2023 23.9951 11.0473 23.9596 10.9035 23.8953C10.7597 23.8309 10.63 23.7388 10.5218 23.6243L0.327819 12.8307C0.117299 12.608 0 12.3132 0 12.0067C0 11.7003 0.117299 11.4055 0.327819 11.1828L10.5218 0.38796C10.6293 0.270956 10.759 0.176474 10.9033 0.110003C11.0476 0.0435333 11.2037 0.00639915 11.3625 0.000757217C11.5212 -0.00488281 11.6796 0.0210819 11.8282 0.0771427C11.9769 0.133205 12.1129 0.218245 12.2284 0.327328C12.3439 0.436409 12.4366 0.567356 12.5011 0.712563C12.5656 0.857771 12.6006 1.01434 12.604 1.17319C12.6075 1.33203 12.5794 1.48997 12.5213 1.63785C12.4632 1.78573 12.3763 1.92059 12.2656 2.03459L2.84874 12.0067L12.2656 21.9765Z"
        fill={dark ? "black" : "white"}
      />
    </svg>
  );
};
